import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []
  static values = {
    search: Boolean
  }

  connect() {
    if (this.searchValue) {
      // add current location's search params to turbo frame request
      this.element.addEventListener('turbo:before-fetch-request', e => {
        // only trigger for search forms

        new URL(window.location).searchParams.forEach((value, key) => {
          if (key[0] === 'q') {
            e.detail.url.searchParams.append(key, value)
          }
        })
      })

      // intercept ransack search submission to set turbo frame's src instead
      this.element.addEventListener('turbo:submit-start', event => {
        if (!event.target.id.includes('search')) return
        event.detail.formSubmission.stop()
        const src = new URL(this.element.getAttribute('src'))
        const location = new URL(window.location.href)

        // clear existing search params from location and src
        function deleteSearchFromParams(params) {
          const keysToDelete = []
          params.keys().forEach(key => {
            if (key[0] === 'q') keysToDelete.push(key)
          })
          keysToDelete.forEach(key => params.delete(key))
        }
        deleteSearchFromParams(src.searchParams)
        deleteSearchFromParams(location.searchParams)

        // TODO: array param for status not gettring written properly

        // for some reason event.detail.formSubmission.body does not contain always the right entries,
        // so we derive the search params from the form element instead
        new FormData(event.target).forEach((value, key) => {
          if (key[0] === 'q' && value) {
            src.searchParams.append(key, value)
            location.searchParams.append(key, value)
          }
        })

        // Location MUST be updated first
        history.replaceState(history.state, '', location.href)
        this.element.setAttribute('src', src.href)
      })
    }

    // This is a bit of a hack. There's an issue with turbo where it removes the 'busy' attribute before the frame is done
    // rendering. This makes it difficult to implement a loading animation based on these attributes. However, the 'complete'
    // attribute is actually added at the correct time, after rendering has finished; to use it for loading states we just have to
    // remove it whenever the frame navigates.
    // Issue: https://github.com/hotwired/turbo-rails/issues/667
    this.element.addEventListener('turbo:before-fetch-request', e => {
      if (e.target === this.element) {
        this.element.removeAttribute('complete')
      }
    })
  }
}
